var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMixNMatchBundleGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5005 7.09858C12.0656 7.92701 10.2308 7.43538 9.40242 6.0005C8.57399 4.56562 9.06562 2.73085 10.5005 1.90243C11.9354 1.074 13.7701 1.56562 14.5986 3.0005C15.427 4.43538 14.9354 6.27015 13.5005 7.09858Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40242 21.0005C10.2308 22.4354 12.0656 22.927 13.5005 22.0986C14.9354 21.2702 15.427 19.4354 14.5986 18.0005C13.7701 16.5656 11.9354 16.074 10.5005 16.9024C9.06562 17.7309 8.57399 19.5656 9.40242 21.0005Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85189 9.77278C3.93299 10.3033 3.61815 11.4783 4.14868 12.3972C4.63313 13.2363 5.6666 13.5833 6.55931 13.2067L16.6638 8.94362C18.4858 8.1749 20.5951 8.88323 21.5839 10.5958C22.6667 12.4713 22.0241 14.8695 20.1486 15.9523L17.6988 17.3667C17.2205 17.6428 16.6089 17.479 16.3328 17.0007C16.0567 16.5224 16.2205 15.9108 16.6988 15.6347L19.1486 14.2203C20.0675 13.6897 20.3824 12.5147 19.8518 11.5958C19.3674 10.7567 18.3339 10.4097 17.4412 10.7863L7.33675 15.0494C5.51472 15.8181 3.4054 15.1098 2.41662 13.3972C1.33381 11.5217 1.9764 9.12354 3.85189 8.04073L6.30169 6.62633C6.77999 6.35019 7.39158 6.51406 7.66772 6.99236C7.94386 7.47065 7.77999 8.08224 7.30169 8.35838L4.85189 9.77278Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixNMatchBundleGrayIcon);
export default __webpack_public_path__ + "static/media/mix-n-match-bundle-gray-icon.c1a679b787492859ca38cdf4d08e192b.svg";
export { ForwardRef as ReactComponent };